// removed by extract-text-webpack-plugin
module.exports = {"container":"_3VBpvx6whZV0vGGYSxJDnN","checkoutCard":"_3uQSemFXTCX1vmfbn5-VGx"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/checkout-success/CheckoutSuccess.css
// module id = 712
// module chunks = 0